module.exports = __webpack_public_path__ + "static/media/Rakieta.63fe151f.svg";